export default {"src":"/customer-services/_next/static/media/logo-john-lewis-for-business.3eb2f9b6.svg","height":23,"width":205,"blurWidth":0,"blurHeight":0};